import errors from './errors/index.js';
import translation from './translation/index.js';
const zh_hk = {
    translation,
    errors,
};
export default Object.freeze(zh_hk);
